import { gql } from '@apollo/client';

export const UPDATE_TRAINING_PHASE = gql`
    mutation updateTrainingPhase($idPhase: ID!, $phaseInput: TrainingPhaseInput!){
        updateTrainingPhase(idPhase: $idPhase, phaseInput: $phaseInput) {
            _id
        }
    }
`;
